export const VENUE = {
  lat: 48.76776,
  lng: 1.20115,
};

// type: 'Hotel' | 'Rental' | 'Airbnb' | 'Gites'
// capacity: string | null
// price: string | null  (null → "See website")
// minNights: number | null  (null → no confirmed minimum)
// available: boolean (optional, defaults to true; false = fully booked Sept 4-6 2026)
export const ACCOMMODATIONS = [
  {
    id: 'private-room-saint-lubin',
    name: 'Private room',
    location: 'Saint-Lubin-des-Joncherets',
    type: 'Airbnb',
    capacity: '4–5 guests',
    distance: 'Walking distance',
    price: '~€258/night',
    minNights: 2,
    url: 'https://www.airbnb.fr/rooms/1103415500591978108',
    lat: 48.768,
    lng: 1.199,
    available: false,
  },
  {
    id: 'villa-la-madeleine-de-nonancourt',
    name: 'Villa La Madeleine-de-Nonancourt',
    location: 'La Madeleine-de-Nonancourt',
    type: 'Rental',
    capacity: '8 guests',
    distance: '~5 min walk',
    price: '~€330/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/villa-la-madeleine-de-nonancourt.fr.html',
    lat: 48.7738,
    lng: 1.2019,
    available: false,
  },
  {
    id: 'appartement-architecte',
    name: 'Appartement maison d\'architecte',
    location: null,
    type: 'Airbnb',
    capacity: '4 guests',
    distance: '~5 min drive',
    price: '~€110/night',
    minNights: null,
    url: 'https://www.airbnb.com/rooms/1673797885855806612',
    lat: 48.7735,
    lng: 1.1900,
    available: false,
  },
  {
    id: 'appartement-nonancourt',
    name: 'Appartement à Nonancourt',
    location: 'Nonancourt',
    type: 'Airbnb',
    capacity: '4 guests',
    distance: '~5 min drive',
    price: '~€209/night',
    minNights: null,
    url: 'https://www.airbnb.com/rooms/1039788094068835482',
    lat: 48.773571,
    lng: 1.184664,
    available: false,
  },
  {
    id: 'gite-de-leglise',
    name: 'Gîte de l\'Église',
    location: null,
    type: 'Gites',
    capacity: '6–7 guests',
    distance: '~5 min drive',
    price: '~€196/night',
    minNights: 2,
    url: 'https://www.gites-de-france.com/fr/normandie/eure/gite-de-leglise-27g948',
    lat: 48.789,
    lng: 1.036,
    available: false,
  },
  {
    id: 'la-maison-oiseaux',
    name: 'La Maison Oiseaux',
    location: null,
    type: 'Gites',
    capacity: '4–6 guests',
    distance: '~7 min drive',
    price: '~€293/night',
    minNights: 2,
    url: 'https://www.gites-de-france.com/fr/normandie/eure/la-maison-oiseaux-27g1185',
    lat: 48.766,
    lng: 1.264,
    available: false,
  },
  {
    id: 'la-berceuse-normande',
    name: 'La Berceuse Normande',
    location: null,
    type: 'Gites',
    capacity: '2–4 guests',
    distance: '~7 min drive',
    price: '~€150/night',
    minNights: 2,
    url: 'https://www.booking.com/hotel/fr/la-berceuse-normande.fr.html',
    lat: 48.7624,
    lng: 1.1491,
    available: false,
  },
  {
    id: 'entire-place-la-madeleine',
    name: 'Entire place',
    location: 'La Madeleine-de-Nonancourt',
    type: 'Airbnb',
    capacity: '2–4 guests',
    distance: '~8 min drive',
    price: '~€212/night',
    minNights: null,
    url: 'https://www.airbnb.fr/rooms/649965649463394256',
    lat: 48.782770,
    lng: 1.236533,
  },
  {
    id: 'maison-piscine-1h-paris',
    name: 'Maison de charme avec piscine à 1h de Paris',
    location: null,
    type: 'Airbnb',
    capacity: '8 guests',
    distance: '~10 min drive',
    price: '~€296/night',
    minNights: null,
    url: 'https://www.airbnb.com/rooms/1371659777447909723',
    lat: 48.705600,
    lng: 1.176358,
    available: false,
  },
  {
    id: 'maisonnette-marcilly-la-campagne',
    name: 'Maisonnette au calme',
    location: 'Marcilly-la-Campagne',
    type: 'Rental',
    capacity: '2–4 guests',
    distance: '~10 min drive',
    price: '~€98/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/maisonnette-au-calme-marcilly-la-campagne.fr.html',
    lat: 48.834,
    lng: 1.203,
    available: false,
  },
  {
    id: 'appartement-saint-remy-sur-avre',
    name: 'Chambre du Courtepointier',
    location: 'Saint-Rémy-sur-Avre',
    type: 'Airbnb',
    capacity: '2 guests',
    distance: '~10 min drive',
    price: '~€110/night',
    minNights: null,
    url: 'https://www.airbnb.fr/rooms/44423070',
    lat: 48.763,
    lng: 1.244,
    available: false,
  },
  {
    id: 'longere-muzy',
    name: 'Magnifique longère',
    location: 'Muzy',
    type: 'Rental',
    capacity: '4–6 guests',
    distance: '~11 min drive',
    price: '~€488/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/magnifique-longere-proche-dreux-et-a-1h-de-paris.fr.html',
    lat: 48.7758,
    lng: 1.3436,
    available: false,
  },
  {
    id: 'la-maison-de-fessanvilliers',
    name: 'La Maison de Fessanvilliers',
    location: null,
    type: 'Airbnb',
    capacity: '4–6 guests',
    distance: '~11 min drive',
    price: '~€127/night',
    minNights: 4,
    url: 'https://www.airbnb.com/rooms/39642510',
    lat: 48.7125,
    lng: 1.0467,
    available: false,
  },
  {
    id: 'maison-normandie-acon',
    name: 'Maison en Normandie — 8 personnes',
    location: 'Acon',
    type: 'Rental',
    capacity: '7 guests',
    distance: '~11 min drive',
    price: '~€112/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/maison-en-normandie-1h15-de-paris-8-personnes.fr.html',
    lat: 48.776,
    lng: 1.0952,
    available: false,
  },
  {
    id: 'lavre-de-paix-acon',
    name: 'L\'Avre de Paix, au bord de l\'eau',
    location: 'Nonancourt',
    type: 'Rental',
    capacity: '9 guests',
    distance: '~11 min drive',
    price: '~€705/night',
    minNights: null,
    url: 'https://www.abritel.fr/location-vacances/p2369848',
    lat: 48.765762,
    lng: 1.101676,
  },
  {
    id: 'timeless-manor-acon',
    name: 'A timeless manor',
    location: 'Acon',
    type: 'Rental',
    capacity: '8 guests',
    distance: '~12 min drive',
    price: '~€1,133/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/manoir-1h-de-paris.fr.html',
    lat: 48.776,
    lng: 1.098,
  },
  {
    id: 'appartement-coudres',
    name: 'Appartement',
    location: 'Coudres',
    type: 'Airbnb',
    capacity: '2–4 guests',
    distance: '~13 min drive',
    price: '~€80/night',
    minNights: null,
    url: 'https://www.airbnb.fr/rooms/708350719096179142',
    lat: 48.8635,
    lng: 1.2452,
    available: false,
  },
  {
    id: 'bb-hotel-dreux-nord',
    name: 'B&B HOTEL Dreux Nord',
    location: 'Dreux',
    type: 'Hotel',
    capacity: null,
    distance: '~14 min drive',
    price: '~€108/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/b-amp-b-dreux-nord.fr.html',
    lat: 48.7468,
    lng: 1.3612,
    available: false,
  },
  {
    id: 'longere-cosy-1h10-paris',
    name: 'Longère cosy à 1 h 10 de Paris',
    location: null,
    type: 'Airbnb',
    capacity: '8 guests',
    distance: '~15 min drive',
    price: '~€237/night',
    minNights: null,
    url: 'https://www.airbnb.com/rooms/898466954745629409',
    lat: 48.763158,
    lng: 1.084964,
    available: false,
  },
  {
    id: 'maison-dhotes-garnay',
    name: 'Maison d\'hôtes',
    location: 'Garnay',
    type: 'Airbnb',
    capacity: '2–4 guests',
    distance: '~18 min drive',
    price: '~€110/night',
    minNights: null,
    url: 'https://www.airbnb.fr/rooms/19608672',
    lat: 48.707,
    lng: 1.338,
    available: false,
  },
  {
    id: 'chateau-montigny-sur-avre',
    name: 'Château de Montigny-sur-Avre',
    location: 'Montigny-sur-Avre',
    type: 'Rental',
    capacity: '38 guests',
    distance: '~19 min drive',
    price: '~€2,100/night',
    minNights: 2,
    noteKey: 'contactIfInterested',
    url: 'https://www.abritel.fr/location-vacances/p2087486',
    lat: 48.729619,
    lng: 1.019958,
    available: false,
  },
  {
    id: 'maison-dame-marie',
    name: 'Maison charmante à Dame-Marie',
    location: null,
    type: 'Rental',
    capacity: '8 guests',
    distance: '~20 min drive',
    price: '~€601/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/holiday-home-les-quatre-vouges.fr.html',
    lat: 48.807,
    lng: 0.997,
  },
  {
    id: 'ibis-styles-dreux',
    name: 'Ibis Styles Dreux Centre Gare',
    location: 'Dreux',
    type: 'Hotel',
    capacity: null,
    distance: '~22 min drive',
    price: '~€182/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/ibis-styles-dreux-centre-gare.fr.html',
    lat: 48.7313,
    lng: 1.3689,
    available: false,
  },
  {
    id: 'petit-cottage-treon',
    name: 'Petit cottage mitoyen',
    location: 'Tréon',
    type: 'Airbnb',
    capacity: '4–5 guests',
    distance: '~25 min drive',
    price: '~€154/night',
    minNights: null,
    url: 'https://www.airbnb.com/rooms/861352711750694368',
    lat: 48.6765,
    lng: 1.3269,
    available: false,
  },
  {
    id: 'la-closerie-des-champs',
    name: 'La Closerie des champs',
    location: null,
    type: 'Gites',
    capacity: '8–10 guests',
    distance: '~25 min drive',
    price: '~€321/night',
    minNights: 2,
    url: 'https://www.gites-de-france.com/fr/normandie/eure/la-closerie-des-champs-27g892',
    lat: 48.876,
    lng: 1.205,
    available: false,
  },
  // Évreux hotels (~30 min drive)
  {
    id: 'best-western-plus-evreux',
    name: 'Best Western Plus Palais des Congrès',
    location: 'Évreux',
    type: 'Hotel',
    capacity: null,
    distance: '~30 min drive',
    price: '~€90–110/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/best-western-plus-evreux-palais-des-congra-s.html',
    lat: 49.02305,
    lng: 1.13704,
    available: false,
  },
  {
    id: 'hotel-de-lorme-evreux',
    name: 'Hôtel de l\'Orme',
    location: 'Évreux',
    type: 'Hotel',
    capacity: null,
    distance: '~30 min drive',
    price: '~€55–75/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/inter-de-l-orme.html',
    lat: 49.02851,
    lng: 1.14878,
  },
  {
    id: 'hotel-de-normandie-evreux',
    name: 'Hôtel de Normandie',
    location: 'Évreux',
    type: 'Hotel',
    capacity: null,
    distance: '~30 min drive',
    price: '~€55–80/night',
    minNights: null,
    url: 'https://www.booking.com/hotel/fr/logis-normandy.fr.html',
    lat: 49.02918,
    lng: 1.15178,
  },
];
